import { StorageType } from "api/entities/shard-repository";
import IOption from "../../shared-ui/common/option";
import { IFilterProps, SelectFilter } from "../../shared-ui/filters/select-filter";

const storageTypeForFilterToNameMap = {
    "S3": "S3",
    "GCS": "Google Cloud Storage",
    "ABS": "Azure Blob Storage",
};

export function StorageTypeFilter(props: IFilterProps<StorageType, IOption<StorageType>>) {

    function getStorageTypeOptions(): IOption<StorageType>[] {
        return Object.keys(storageTypeForFilterToNameMap).map(x => ({ value: x as StorageType, label: storageTypeForFilterToNameMap[x] }));
    }

    return SelectFilter({
        testId: "type-filter",
        label: "Type",
        optionAsValue: true,
        options: () => Promise.resolve(getStorageTypeOptions()),
        ...props
    });
}
